interface MarkerProps {
    lat?: number
    lng?: number
    style?: any
}

export const Collection: React.FC<MarkerProps> = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-primary-500 transform -translate-x-1/2 -translate-y-1/2"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
    </svg>
)

export const LocationMarker: React.FC<MarkerProps> = () => (
    <div>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7 text-primary-500 transform -translate-x-1/2 -translate-y-1/2"
            viewBox="0 0 20 20"
            fill="currentColor">
            <path
                fillRule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
            />
        </svg>
    </div>
)

export const Truck: React.FC<MarkerProps> = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-7 w-7 text-primary-500 transform -translate-x-1/2 -translate-y-1/2"
        viewBox="0 0 20 20"
        fill="currentColor">
        <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
        <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
    </svg>
)
